import { render, staticRenderFns } from "./IconSvgIcons8Support.vue?vue&type=template&id=6e664512&scoped=true&"
import script from "./IconSvgIcons8Support.vue?vue&type=script&lang=js&"
export * from "./IconSvgIcons8Support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e664512",
  null
  
)

export default component.exports